export const SHARED_WINDOW_HEIGHT = 225;
export const CHAT_DRAWER_WIDTH = 400;
export const DRAWER_WIDTH = 422;
